import { getAuthState } from '../hooks/useAuth';

interface resumoSiteTech {
    scripts: Script[];
    resumo: string;
}

interface Script {
    nome: string;
    descricao: string;
    codigo_identificado: string;
}

let auth = getAuthState()
export const resumoSiteTech = async (URL: string): Promise<resumoSiteTech> => { 
    try {

            auth = getAuthState()
            const response = await fetch('https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/tech', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': auth.idToken,
                },
                body: JSON.stringify({ url: URL })
            });

            if (!response.ok) {
                throw new Error(`Requisition error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return JSON.parse(data.body);
              
        } catch (error) {
            console.error('Error fetching files:', error);
            return { scripts: [], resumo: '' }
        }
};